// ----------------------------------------------------------------------------
// UX Enhancements
// ----------------------------------------------------------------------------

var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var INPUT_WRAPPER = '.form__field';

var INPUT_ELEMENTS = 'input,select,textarea';
var NOT_ELEMENTS = 'input[type=button],button';

module.exports = function() {
    $(document).on('click', INPUT_WRAPPER, function(event){
        $inputs = $(this).find(INPUT_ELEMENTS).not(NOT_ELEMENTS);
        if ( $inputs.length ){
            $inputs.get(0).focus();
        }
    });
};
